module.exports = __webpack_public_path__ + "static/media/w5s.1571f6ff.svg";